var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2915_9365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52941 7.05882C5.17094 7.05882 6.55435 5.93235 6.94718 4.41177H10.5262L9.676 5.68706L11.1444 6.66594L13.2353 3.52941L11.1443 0.392941L9.67594 1.37176L10.5262 2.64706H6.94712C6.55435 1.12647 5.17094 0 3.52941 0C1.58329 0 0 1.58329 0 3.52941C0 5.47553 1.58329 7.05882 3.52941 7.05882Z",
    fill: "#00A751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4706 30C28.4198 30 30 28.4198 30 26.4706C30 24.5213 28.4198 22.9412 26.4706 22.9412C24.5213 22.9412 22.9412 24.5213 22.9412 26.4706C22.9412 28.4198 24.5213 30 26.4706 30Z",
    fill: "#00A751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4706 2.64703H20.1723C19.8081 1.62003 18.8273 0.882324 17.677 0.882324C16.2173 0.882324 15.0299 2.06985 15.0299 3.52938C15.0299 4.98897 16.2174 6.17644 17.677 6.17644C18.8273 6.17644 19.8081 5.43874 20.1723 4.41174H26.4706C27.4437 4.41174 28.2353 5.20338 28.2353 6.17644V12.3529C28.2353 13.326 27.4437 14.1176 26.4706 14.1176H22.1499L23.0001 12.8423L21.5318 11.8634L19.4408 15L21.5318 18.1364L23.0001 17.1576L22.1499 15.8823H26.4706C28.4168 15.8823 30.0001 14.299 30.0001 12.3529V6.17644C30.0001 4.23032 28.4168 2.64703 26.4706 2.64703ZM17.6172 24.3129L18.4674 25.5882H14.8483C14.4841 24.5612 13.5033 23.8235 12.353 23.8235C10.8935 23.8235 9.70593 25.0109 9.70593 26.4706C9.70593 27.9302 10.8935 29.1176 12.353 29.1176C13.5033 29.1176 14.484 28.3799 14.8483 27.3529H18.4674L17.6172 28.6282L19.0855 29.6071L21.1765 26.4706L19.0855 23.3341L17.6172 24.3129Z",
    fill: "#00A751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38182 24.3129L5.23206 25.5882H3.49953C2.52676 25.5882 1.76471 24.813 1.76471 23.8235V17.647C1.76471 16.674 2.55635 15.8823 3.52941 15.8823H12.5047C12.8689 16.9093 13.8497 17.647 15 17.647C16.4596 17.647 17.6471 16.4596 17.6471 15C17.6471 13.5404 16.4596 12.3529 15 12.3529C13.8497 12.3529 12.869 13.0906 12.5047 14.1176H3.52941C1.58329 14.1176 0 15.7009 0 17.647V23.8235C0 24.7655 0.360059 25.6501 1.01388 26.3143C1.67324 26.984 2.556 27.3529 3.49953 27.3529H5.23206L4.38182 28.6282L5.85018 29.6071L7.94118 26.4706L5.85018 23.3341L4.38182 24.3129Z",
    fill: "#00A751"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2915_9365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningIcon);
export default __webpack_public_path__ + "static/media/planningIcon.9128df3383f97a41dc9be2d8946a7c13.svg";
export { ForwardRef as ReactComponent };